import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'home',
    redirect: '/home',
  },
  {
    path: '/home',
    component: Layout,
    meta: {
      hasCooperation: true
    },
    children: [
      {
        path: '',
        name: '首页',
        component: () => import('../views/home/Home.vue')
      }
    ]
  },
  {
    path: '/product',
    name: '核心产品',
    redirect: '/product/list',
    component: Layout,
    children: [
      {
        path: '/product/list',
        name: '水质监测',
        component: () => import('../views/product/List.vue')
      },
      // {
      //   path: '/product/qtjc',
      //   name: '气体监测',
      //   component: () => import('../views/product/List.vue')
      // },
      {
        path: '/product/sctt',
        name: '数采和探头',
        component: () => import('../views/product/List.vue')
      },
      {
        path: '/product/yjfn',
        name: '解决方案',
        component: () => import('../views/product/List.vue')
      },
      {
        path: '/product/detail',
        name: '产品详情',
        component: () => import('../views/product/Detail.vue')
      },
     
    ]
  },
  {
    path: '/case',
    name: '成功案例',
    redirect: '/case/list',
    component: Layout,
    children: [
      {
        path: '/case/list',
        name: '成功案例',
        component: () => import('../views/case/index.vue')
      },
      {
        path: '/case/Detail',
        name: '成功案例详情',
        component: () => import('../views/case/Detail.vue')
      },
    ]
  },
  {
    path: '/news',
    name: '新闻中心',
    redirect: '/news/list',
    component: Layout,
    children: [
      {
        path: '/news/list',
        name: '新闻列表',
        component: () => import('../views/news/List.vue')
      },
      {
        path: '/news/detail',
        name: '新闻详情',
        component: () => import('../views/news/Detail.vue')
      }
    ]
  },
  {
    path: '/about',
    name: '关于',
    redirect: '/about',
    component: Layout,
    meta: {
      hasCooperation: true
    },
    children: [
      {
        path: '',
        name: '关于我们',
        component: () => import('../views/about/AboutUs.vue')
      }
    ]
  },
  {
    path: '/contact',
    name: '联系',
    redirect: '/contact/list',
    component: Layout,
    meta: {
      hasCooperation: true
    },
    children: [
      {
        path: '/contact/list',
        name: '联系我们',
        component: () => import('../views/contact/ContactUs.vue')
      },
      {
        path: '/contact/dlsmh',
        name: '代理商门户',
        component: () => import('../views/contact/dlsmh.vue')
      },
      {
        path: '/contact/zpmh',
        name: '招聘门户',
        component: () => import('../views/contact/zpmh.vue')
      }
    ]
  },
  {
    path: '/application',
    name: '应用领域',
    redirect: '/application',
    component: Layout,
    children: [
      {
        path: '',
        name: '应用详情',
        component: () => import('../views/application/Detail.vue')
      }
    ]
  },
  {
    path: '/others',
    name: '隐私',
    redirect: '/others/Terms',
    component: Layout,
    children: [
      {
        path: '/others/Terms',
        name: '隐私权政策',
        component: () => import('../views/others/Terms.vue')
      }
      
    ]
    
  },
  {
    path: '/others',
    name: '条款',
    redirect: '/others/Privacypolicy',
    component: Layout,
    children: [
      {
        path: '/others/Privacypolicy',
        name: '使用条款',
        component: () => import('../views/others/Privacypolicy.vue')
      }
      
    ]
    
  },
  {
    path: '/others',
    name: '网站地图',
    redirect: '/others/gis',
    component: Layout,
    children: [
      {
        path: '/others/gis',
        name: '网站地图',
        component: () => import('../views/others/gis.vue')
      }
      
    ]
    
  },
  
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes
})

export default router
